import React from 'react';
import './App.css';
// import Card from './components/Home/Card/Card';
import Home from './components/Home/Home';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
